import App from '../App'
const myBooking = r => require.ensure([], () => r(require('../page/membership/myBooking')), 'myBooking')
const userBookingDetail = r => require.ensure([], () => r(require('../page/membership/children/userBookingDetail')), 'userBookingDetail')
const home = r => require.ensure([], () => r(require('../page/home/home')), 'home')
const membership = r => require.ensure([], () => r(require('../page/membership/membership')), 'membership')
const register = r => require.ensure([], () => r(require('../page/membership/register')), 'register')
const survey = r => require.ensure([], () => r(require('../page/membership/survey')), 'survey')
const booking = r => require.ensure([], () => r(require('../page/membership/children/booking')), 'booking')
const newBooking = r => require.ensure([], () => r(require('../page/membership/newBooking')), 'newBooking')
const ffSkin = r => require.ensure([], () => r(require('../page/membership/ffSkin')), 'ffSkin')
const brandjoin = r => require.ensure([], () => r(require('../page/membership/brandjoin')), 'brandjoin')
const brandjoin2 = r => require.ensure([], () => r(require('../page/membership/brandjoin2')), 'brandjoin2')
const storeList = r => require.ensure([], () => r(require('../page/membership/children/storeList')), 'storeList')
const updateGoodsMember = r => require.ensure([], () => r(require('../page/membership/children/updateGoodsMember')), 'updateGoodsMember')
const updateEmployeeMember = r => require.ensure([], () => r(require('../page/membership/children/updateEmployeeMember')), 'updateEmployeeMember')
const updateBookingMember = r => require.ensure([], () => r(require('../page/membership/children/updateBookingMember')), 'updateBookingMember')
const memberBookingInfo = r => require.ensure([], () => r(require('../page/membership/children/memberBookingInfo')), 'memberBookingInfo')
const ackBooking = r => require.ensure([], () => r(require('../page/membership/children/ackBooking')), 'ackBooking')
const bkSuccess = r => require.ensure([], () => r(require('../page/membership/children/bkSuccess')), 'bkSuccess')
const submitBooking = r => require.ensure([], () => r(require('../page/membership/children/submitBooking')), 'submitBooking')
const updateFail = r => require.ensure([], () => r(require('../page/membership/children/updateFail')), 'updateFail')
const updateFails = r => require.ensure([], () => r(require('../page/shopkeeper/children/updateFails')), 'updateFails')
const bookFail = r => require.ensure([], () => r(require('../page/membership/children/bookFail')), 'bookFail')
const bookingClose = r => require.ensure([], () => r(require('../page/membership/children/bookingClose')), 'bookingClose')
const bookSuccess = r => require.ensure([], () => r(require('../page/membership/children/bookSuccess')), 'bookSuccess')
const bookingDetail = r => require.ensure([], () => r(require('../page/membership/children/bookingDetail')), 'bookingDetail')
const purchaseGoods = r => require.ensure([], () => r(require('../page/membership/children/purchaseGoods')), 'purchaseGoods')
const changeGoods = r => require.ensure([], () => r(require('../page/membership/children/changeGoods')), 'changeGoods')
const updateGoods = r => require.ensure([], () => r(require('../page/shopkeeper/children/updateGoods')), 'updateGoods')
const chooseGoods = r => require.ensure([], () => r(require('../page/membership/children/chooseGoods')), 'chooseGoods')
const purchaseGoods1 = r => require.ensure([], () => r(require('../page/membership/children/purchaseGoods1')), 'purchaseGoods1')
const bookingInfo = r => require.ensure([], () => r(require('../page/membership/children/bookingInfo')), 'bookingInfo')
const updateBooking = r => require.ensure([], () => r(require('../page/shopkeeper/children/updateBooking')), 'updateBooking')
const chooseEmployee = r => require.ensure([], () => r(require('../page/membership/children/chooseEmployee')), 'chooseEmployee')
const updateEmployee = r => require.ensure([], () => r(require('../page/shopkeeper/children/updateEmployee')), 'updateEmployee')
const selectEmployee = r => require.ensure([], () => r(require('../page/membership/children/selectEmployee')), 'selectEmployee')
const consume = r => require.ensure([], () => r(require('../page/membership/children/consume')), 'consume')
const evaluate = r => require.ensure([], () => r(require('../page/membership/children/evaluate')), 'evaluate')
const shopkeeper = r => require.ensure([], () => r(require('../page/shopkeeper/shopkeeper')), 'shopkeeper')
const member = r => require.ensure([], () => r(require('../page/shopkeeper/children/member')), 'member')
const memberSms = r => require.ensure([], () => r(require('../page/shopkeeper/children/memberSms')), 'memberSms')
const myStaff = r => require.ensure([], () => r(require('../page/shopkeeper/children/children/myStaff')), 'myStaff')
const bookingList = r => require.ensure([], () => r(require('../page/shopkeeper/children/bookingList')), 'bookingList')
const bookingView = r => require.ensure([], () => r(require('../page/shopkeeper/children/bookingView')), 'bookingView')
const myStaffList = r => require.ensure([], () => r(require('../page/shopkeeper/children/myStaffList')), 'myStaffList')
const productOrder = r => require.ensure([], () => r(require('../page/shopkeeper/children/productOrder')), 'productOrder')

const account = r => require.ensure([], () => r(require('../page/shopkeeper/children/account')), 'account')
const performance = r => require.ensure([], () => r(require('../page/shopkeeper/children/performance')), 'performance')
const info = r => require.ensure([], () => r(require('../page/shopkeeper/children/children/info')), 'info')
const goods = r => require.ensure([], () => r(require('../page/shopkeeper/children/children/goods')), 'goods')
const smsHistory = r => require.ensure([], () => r(require('../page/shopkeeper/children/children/smsHistory')), 'smsHistory')
const activity = r => require.ensure([], () => r(require('../page/shopkeeper/children/children/activity')), 'activity')
const pmember = r => require.ensure([], () => r(require('../page/shopkeeper/children/children/pmember')), 'pmember')
const ymPointsList = r => require.ensure([], () => r(require('../page/shopkeeper/children/children/ymPointsList')), 'ymPointsList')
const ymCashOutList = r => require.ensure([], () => r(require('../page/shopkeeper/children/children/ymCashOutList')), 'ymCashOutList')
const ymPoints = r => require.ensure([], () => r(require('../page/shopkeeper/children/ymPoints')), 'ymPoints')
const ymPointsCashOut = r => require.ensure([], () => r(require('../page/shopkeeper/children/children/ymPointsCashOut')), 'ymPointsCashOut')
const productDetail = r => require.ensure([], () => r(require('../page/shopkeeper/children/productDetail')), 'productDetail')
const traceProduct = r => require.ensure([], () => r(require('../page/traceProduct/index')), 'traceProduct')
const companyTraceProduct = r => require.ensure([], () => r(require('../page/traceProduct/companyIndex')), 'companyIndex')
const f88_trans = r => require.ensure([], () => r(require('../page/sharkentry5p/f88_trans')), 'f88_trans')
const showVideo = r => require.ensure([], () => r(require('../page/video/index')), 'showVideo')
const wxPay = r => require.ensure([], () => r(require('../page/pay/wxPay')), 'wxPay')
const RndCommodity = r => require.ensure([], () => r(require('../page/pay/RndCommodity')), 'RndCommodity')
const RndWxPay = r => require.ensure([], () => r(require('../page/pay/RndWxPay')), 'RndWxPay')
export default [{
    path: '/',
    component: App,
    children: [
        {
            path: '',
            redirect: '/home'
        },
        {
            path: '/home',
            component: home
        },
        {
            path: '/register',
            component: register,
        },
          {
            path: '/survey',
            component: survey,
            meta:{
                title:'健康登记'
            }
        },
      {
        path: '/newBooking',
        component: newBooking,
      },
      {
        path: '/ffSkin',
        component: ffSkin,
      },   {
        path: '/brandjoin',
        component: brandjoin,
         meta:{
                title:'我要加盟'
            }
      },
      {
        path: '/traceProduct/:code',
        component: traceProduct,
        meta:{
          title:'产品追溯'
            }
      },
      {
        path: '/video',
        component: showVideo,
        meta:{
          title:'视频'
            }
      },
      {
        path: '/wxPay',
        component: wxPay,
        meta:{
          title:'支付'
            }
      },
      {
        path: '/RndCommodity',
        component: RndCommodity,
        meta:{
          title:'商品'
            }
      },
      {
        path: '/RndWxPay',
        component: RndWxPay,
        meta:{
          title:'Rnd支付'
            }
      },
       {
        path: '/companyTrace/:code',
        component: companyTraceProduct,
        meta:{
                title:'产品追溯'
            }
      },  {
        path: '/brandjoin2',
        component: brandjoin2,
        meta:{
          title:'我要加盟'
        }
      },
        {
            path: '/membership',
            component: membership,
            meta: { keepAlive: false },
            children:[{
                path: 'booking',
                component: booking,
             },
             {
                path: 'storeList',
                component: storeList,

             },
              {
                path: 'updateGoodsMember',
                component: updateGoodsMember,
              },  {
                path: 'updateEmployeeMember',
                component: updateEmployeeMember,
              },  {
                path: 'updateBookingMember',
                component: updateBookingMember,
              }, {
                path: 'memberBookingInfo',
                component: memberBookingInfo,
              },{
                path: 'purchaseGoods',
                component: purchaseGoods,
              },{
                path: 'changeGoods',
                component: changeGoods,
              },{
                path: 'chooseGoods',
                component: chooseGoods,
              },{
                path: 'purchaseGoods1',
                component: purchaseGoods1,
              },{
                path: 'bookingInfo',
                component: bookingInfo,
              },{
                path: 'chooseEmployee',
                component: chooseEmployee,
              },{
                path: 'selectEmployee',
                component: selectEmployee,
              },{
                path: 'ackBooking',
                component: ackBooking,
              },{
                path: 'bookingDetail',
                component: bookingDetail,
              },{
                path: 'bkSuccess',
                component: bkSuccess,
              },{
                path: 'bookSuccess',
                component: bookSuccess,
              }, {
                path: 'submitBooking',
                component: submitBooking,
              },  {
                path: 'bookFail',
                component: bookFail,
              },{
                path: 'bookingClose',
                component: bookingClose,
              },{
                path: 'updateFail',
                component: updateFail,
              }, {
                path: 'evaluate',
                component: evaluate,
             },{
                path: 'consume',
                component: consume,
             }]
        },
        {
            path: '/shopkeeper',
            component: shopkeeper,
            children:[
               {
                   path: 'member',
                   component: member,
                   children:[{
                      path: 'info',
                      component: info,
                   }]
                },
              {
                path: 'bookingView',
                component: bookingView,
              },
              {
                path: 'updateFails',
                component: updateFails,
              },
              {
                path: 'updateGoods',
                component: updateGoods,
              },
              {
                path: 'updateEmployee',
                component: updateEmployee,
              },
              {
                path: 'updateBooking',
                component: updateBooking,
              },
               {
                  path: 'bookingList',
                  component: bookingList,
                },
                {
                  path: 'account',
                  component: account,
                },
               {
                  path: 'myStaffList',
                  component: myStaffList,
                  children:[{
                      path: 'myStaff',
                      component: myStaff,
                  }]
                },
               {
                path: 'productOrder',
                component: productOrder,
                children:[{
                  path: 'productOrder',
                  component: productOrder,
                }]
              },
              {
              path: 'productDetail',
              component: productDetail,
              children:[{
                path: 'productDetail',
                component: productDetail,
              }]
              },

                {
                   path: 'memberSms',
                   component: memberSms,
                   children:[{
                        path: 'smsHistory',
                        component: smsHistory,
                   }]
                },
                {
                   path: 'performance',
                   component: performance,
                   children:[{
                        path: 'goods',
                        component: goods,
                   },{
                        path: 'activity',
                        component: activity,
                   },{
                        path: 'pmember',
                        component: pmember,
                   }]
                },
                {
                    path: 'ymPoints',
                    component: ymPoints,
                    children:[{
                        path: 'ymPointsList',
                        component: ymPointsList
                    },{
                      path: 'ymPointsCashOut',
                      name: 'ymPointsCashOut',
                      component: ymPointsCashOut
                    },

                    {
                      path: 'ymCashOutList',
                      component: ymCashOutList
                    }
                    ]
                },
            ]
        },
        {
          path: '/myBooking',
          component: myBooking,
          children:[{
            path: 'userBookingDetail',
            component: userBookingDetail
         }],
        },
        {
          path: '/sharkentry5p',
          component: f88_trans,
          children:[{
            path: 'f88_trans',
            component: f88_trans,
             meta:{
                title:'F88测肤'
            }
         }],
        }
    ]
}]



// WEBPACK FOOTER //
// ./src/router/router.js